//CAREFUL MUST BE THE SAME AS ON DB
export var OrderStatusEnum;
(function (OrderStatusEnum) {
    OrderStatusEnum[OrderStatusEnum["ORDER_STATE_OPEN"] = 1] = "ORDER_STATE_OPEN";
    OrderStatusEnum[OrderStatusEnum["ORDER_STATE_FIRST_REMINDER"] = 2] = "ORDER_STATE_FIRST_REMINDER";
    OrderStatusEnum[OrderStatusEnum["ORDER_STATE_SECOND_REMINDER"] = 3] = "ORDER_STATE_SECOND_REMINDER";
    OrderStatusEnum[OrderStatusEnum["ORDER_STATE_REMINDER_NO_SUCCESS"] = 4] = "ORDER_STATE_REMINDER_NO_SUCCESS";
    OrderStatusEnum[OrderStatusEnum["ORDER_STATE_PAYED"] = 5] = "ORDER_STATE_PAYED";
    OrderStatusEnum[OrderStatusEnum["ORDER_STATE_STORNO"] = 6] = "ORDER_STATE_STORNO";
})(OrderStatusEnum || (OrderStatusEnum = {}));
